import { SimplexNoise } from 'three/addons/math/SimplexNoise.js';
import { mulberry32 } from './rng';

/**
 * Seeded 3D simplex noise on the CPU, and fractal sums of it. Worker-safe (the simplex
 * add-on has no imports). Keep coordinates small (local to what you're building): far
 * from the origin the lattice arithmetic loses precision.
 */
export class Noise3 {
  private readonly simplex: SimplexNoise;

  constructor(seed: number) {
    this.simplex = new SimplexNoise({ random: mulberry32(seed) });
  }

  /** Simplex noise, about [-1, 1]. */
  noise(x: number, y: number, z: number): number {
    return this.simplex.noise3d(x, y, z);
  }

  /** `octaves` layers, each at about twice the frequency and `gain` times the weight; about [-1, 1]. */
  fbm(x: number, y: number, z: number, octaves = 3, gain = 0.5): number {
    let sum = 0;
    let amp = 1;
    let norm = 0;
    let f = 1;
    for (let i = 0; i < octaves; i++) {
      sum += amp * this.simplex.noise3d(x * f + i * 17.3, y * f - i * 9.1, z * f + i * 5.7);
      norm += amp;
      amp *= gain;
      f *= 2.03;
    }
    return sum / norm;
  }
}
